import { localize } from "@gtmhub/localization";

export function notificationsCadenceType() {
  return function (text: string) {
    if (text === "Daily") {
      return localize("daily");
    }

    if (text === "Weekly") {
      return localize("weekly");
    }

    if (text === "Monthly") {
      return localize("monthly");
    }

    if (text === "BiWeekly") {
      return localize("every_two_weeks");
    }

    return "Invalid planning session cadence type";
  };
}
